import React from "react";
import NotificationListings from "../../Components/Notification/NotificationListings";
import NotificationBreadCrumb from "../../Components/Notification/NotificationBreadCrumb";

export default function NotificationListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <NotificationBreadCrumb />
        <NotificationListings />
      </div>
    </React.Fragment>
  );
}
